import { render } from "./Tab3.vue?vue&type=template&id=564f2d2e"
import script from "./Tab3.vue?vue&type=script&lang=ts"
export * from "./Tab3.vue?vue&type=script&lang=ts"
script.render = render

export default script